/**
 * NPS.ACTIONS
 * Route for net promoter score calculation
 */

// Aucun paramètre : le `participation` et le `surveyId` envoyés jusqu'au 2026-09-21 ne servaient
// qu'à la dimension "taille d'entreprise" du benchmark, abandonnée côté calcul (toutes les lignes
// sont écrites en size='all') et jamais lue par le front.
export const benchmarkFetchNps = () => ({
  type: "API",
  payload: {
    method: "GET",
    url: "/benchmark/nps"
  }
})

export const benchmarkFetchQuestions = () => ({
  type: "API",
  payload: {
    method: "GET",
    url: "/benchmark/questions"
  }
})
